export const staticTexts = (lang) => {
  if (lang === "en") {
    return {
      breakingNewsTitle: "Breaking News",
      buttonText: "Read More",
      timeToRead: "min read",
      authorName: "Toufique Imrose Khalidi",
      authorRole: "Editor-in-Chief and Publisher",
      readMoreStoriesHeading: "READ MORE",
      readMoreStoriesButton: "Load More",
      relatedStoriesHeading: "RELATED STORIES",
      languageToggleButton: "বাংলা",
      sortBy: "Sort By",
      relevance: "Relevance",
      newest: "Newest",
      filter: "Filter",
      search: "Search",
      typeHere: "Type Here",
      clear: "Clear",
      section: "Section",
      author: "Author",
      storyType: "Story Type",
      date: "Date",
      to: "to",
      templateOptions: ["text", "photo", "gallery", "video", "video-2", "live-blog"],
      ago: "ago",
      minute: "minute",
      second: "second",
      hour: "hour",
      minutes: "minutes",
      seconds: "seconds",
      hours: "hours",
      localizedMonths: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
      },
      localizedMeridiem: { am: "am", pm: "pm" },
      oldStoriesMessage:
        "The editor-in-chief disclaims all responsibilities for any content published before June 2006.",
    };
  } else {
    return {
      breakingNewsTitle: "সর্বশেষ",
      buttonText: "আরও",
      timeToRead: "মিনিট পড়া",
      authorName: "তৌফিক ইমরোজ খালিদী",
      authorRole: "প্রধান সম্পাদক ও প্রকাশক",
      readMoreStoriesHeading: "আরও পড়ুন",
      readMoreStoriesButton: "আরও",
      relatedStoriesHeading: "এ সম্পর্কিত খবর",
      languageToggleButton: "English",
      sortBy: "কীভাবে দেখতে চান",
      relevance: "প্রাসঙ্গিকতা",
      newest: "নতুন থেকে পুরনো",
      filter: "ফিল্টার",
      search: "খুঁজুন",
      typeHere: "লিখুন",
      clear: "পরিষ্কার",
      section: "সেকশন",
      author: "লেখক",
      storyType: "খবরের ধরন",
      date: "তারিখ",
      to: "থেকে",
      templateOptions: ["টেক্সট", "ছবি", "ছবিঘর", "ভিডিও", "ভিডিও-২", "লাইভ"],
      ago: "আগে",
      minute: "মিনিট",
      second: "সেকেন্ড",
      hour: "ঘন্টা",
      minutes: "মিনিট",
      seconds: "সেকেন্ড",
      hours: "ঘন্টা",
      localizedMonths: {
        jan: "জানুয়ারি",
        feb: "ফেব্রুয়ারি",
        mar: "মার্চ",
        apr: "এপ্রিল",
        may: "মে",
        jun: "জুন",
        jul: "জুলাই",
        aug: "অগাস্ট",
        sep: "সেপ্টেম্বর",
        oct: "অক্টোবর",
        nov: "নভেম্বর",
        dec: "ডিসেম্বর",
      },
      localizedMeridiem: { am: "আ.ম", pm: "প.ম" },
      localizedZeroToPad: "০",
      oldStoriesMessage: "২০০৬ সালের জুন মাসের আগে প্রকাশিত কোনো প্রতিবেদনের দায়-দায়িত্ব প্রধান সম্পাদক বহন করবেন না।",
    };
  }
};
